import React, { useState } from 'react';
import { Form, Input, Button, Radio, Alert } from 'antd';
import {
  getNameRules,
  getFunctionRules,
  getPhoneRules,
  getPasswordRules,
  getZipcodeRules,
  getRequiredTextRules,
} from '../../helper-function/validationRules';
import AccountingFirmActivitySelect from '../../misc/AccountingFirmActivitySelect';

/**
 * Slide 2 : Mot de passe + Déclarant + Cabinet comptable
 * - Affiché UNIQUEMENT si userExists === false
 * - Mot de passe + confirmation
 * - Champs déclarant (nom, prénom, fonction, téléphone)
 * - Type déclarant (INTERNAL / EXTERNAL)
 * - Si EXTERNAL : champs cabinet comptable
 */
const StepPasswordDeclarant = ({ onNext, onPrev }) => {
  const [form] = Form.useForm();
  const [declarantType, setDeclarantType] = useState('INTERNAL');

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onNext(values);
    } catch (err) {
      // Erreurs de validation affichées par Ant Design
    }
  };

  return (
    <div className="step-password-declarant">
      <Alert
        message="Étape 2 : Création du compte"
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
        initialValues={{ declarantType: 'INTERNAL' }}
      >
        {/* Mot de passe */}
        <h4 style={{ marginTop: 24 }}>Mot de passe</h4>

        <Form.Item
          label="Mot de passe"
          name="plainPassword"
          rules={getPasswordRules()}
        >
          <Input.Password
            placeholder="Mot de passe"
            size="large"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          label="Confirmation du mot de passe"
          name="password2"
          dependencies={['plainPassword']}
          rules={[
            { required: true, message: 'Veuillez confirmer votre mot de passe' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('plainPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Les mots de passe ne correspondent pas'));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="Confirmez votre mot de passe"
            size="large"
            autoComplete="new-password"
          />
        </Form.Item>

        {/* Déclarant */}
        <h4 style={{ marginTop: 32 }}>Déclarant (comptable ou personne déléguée, interne ou externe)</h4>

        <Form.Item
          label="Nom"
          name="declarantLastname"
          rules={getNameRules("Le nom du déclarant")}
        >
          <Input placeholder="Nom du déclarant" size="large" />
        </Form.Item>

        <Form.Item
          label="Prénom"
          name="declarantFirstname"
          rules={getNameRules("Le prénom du déclarant")}
        >
          <Input placeholder="Prénom du déclarant" size="large" />
        </Form.Item>

        <Form.Item
          label="Fonction"
          name="declarantFunction"
          rules={getFunctionRules("La fonction du déclarant")}
        >
          <Input placeholder="Ex: Comptable, Gérant, etc." size="large" />
        </Form.Item>

        <Form.Item
          label="Téléphone"
          name="declarantPhone"
          rules={getPhoneRules()}
        >
          <Input placeholder="0123456789" size="large" />
        </Form.Item>

        <Form.Item
          label="Type de déclarant"
          name="declarantType"
          rules={[{ required: true }]}
        >
          <Radio.Group
            onChange={(e) => setDeclarantType(e.target.value)}
            size="large"
          >
            <Radio value="INTERNAL">Interne (personne de l'entreprise)</Radio>
            <Radio value="EXTERNAL">Externe (prestataire externe)</Radio>
          </Radio.Group>
        </Form.Item>

        {/* Cabinet comptable (si EXTERNAL) */}
        {declarantType === 'EXTERNAL' && (
          <>
            <h4 style={{ marginTop: 32 }}>Informations du prestataire externe</h4>

            <Form.Item
              label="Nom du prestataire externe (précisez s'il s'agit d'un cabinet comptable)"
              name="accountingFirmName"
              rules={getRequiredTextRules("Le nom du prestataire")}
            >
              <Input placeholder="Nom du prestataire" size="large" />
            </Form.Item>

            <Form.Item
              label="Activité du prestataire externe"
              name="accountingFirmActivity"
              rules={[{ required: true, message: "L'activité du prestataire est requise" }]}
            >
              <AccountingFirmActivitySelect size="large" />
            </Form.Item>

            <Form.Item
              label="Adresse"
              name="accountingFirmAddress"
              rules={getRequiredTextRules("L'adresse")}
            >
              <Input placeholder="Adresse complète" size="large" autoComplete="new-password" />
            </Form.Item>

            <Form.Item
              label="Code postal"
              name="accountingFirmZipcode"
              rules={getZipcodeRules()}
            >
              <Input placeholder="75001" size="large" autoComplete="new-password" />
            </Form.Item>

            <Form.Item
              label="Ville"
              name="accountingFirmCity"
              rules={getRequiredTextRules("La ville")}
            >
              <Input placeholder="Paris" size="large" autoComplete="new-password" />
            </Form.Item>
          </>
        )}

        {/* Boutons de navigation */}
        <Form.Item style={{ marginTop: 32 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={onPrev} size="large">
              Précédent
            </Button>
            <Button type="primary" htmlType="submit" size="large">
              Suivant
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default StepPasswordDeclarant;
